import React from "react";
import Window from "./Window";
import ActionSheet from "./ActionSheet";
import { isMobileApp } from "../../../actions/Util";

const textOf = (node) =>
  React.Children.toArray(node)
    .map((c) => (typeof c === "string" || typeof c === "number" ? c : ""))
    .join(" ")
    .replace(/\s+/g, " ")
    .trim();

// Reads the choices out of the popup's <Button> / <button> children
const collectChoices = (node, choices = []) => {
  React.Children.forEach(node, (child) => {
    if (!React.isValidElement(child)) return;
    const { text, onClick, icon, children } = child.props;
    const label = text || (child.type === "button" ? textOf(children) : "");
    if (label && onClick) {
      choices.push({ label, icon, onClick, disabled: child.props.disabled || child.props.processing });
    } else if (children) {
      collectChoices(children, choices);
    }
  });
  return choices;
};

// A popup whose body is a list of buttons. The web keeps the original centred
// Window; phones show the same buttons as a bottom sheet.
const ChoicePopup = ({ header, sheetTitle, height, onClose, stripNew, children }) => {
  if (isMobileApp()) {
    const choices = collectChoices(children);
    if (choices.length > 0) {
      const isDanger = (label) => /\b(delete|cancel|reject|remove)\b/i.test(label);
      return (
        <ActionSheet
          title={sheetTitle || header}
          onClose={onClose}
          items={choices.map((c) => ({
            // The title already says "New Transaction"
            label: stripNew ? c.label.replace(/^new\s+/i, "") : c.label,
            icon: c.icon,
            danger: isDanger(c.label),
            showChevron: true,
            disabled: c.disabled,
            onClick: c.onClick
          }))}
        />
      );
    }
  }
  return (
    <Window
      header={header}
      {...(height !== undefined ? { height } : {})}
      modal={true}
      onClose={onClose}
      buttons={[]}
    >
      {children}
    </Window>
  );
};

export default ChoicePopup;
